import { render, staticRenderFns } from "./Garantia.vue?vue&type=template&id=cbef0e8a&"
import script from "./Garantia.vue?vue&type=script&lang=js&"
export * from "./Garantia.vue?vue&type=script&lang=js&"
import style0 from "./Garantia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports